import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form__set" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label"
}, " Title ", -1 /* HOISTED */)
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Add asset",
    onCloseModal: _cache[1] || (_cache[1] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("input", {
          id: "title",
          value: $setup.title,
          class: "form__input form__input--stretch",
          type: "text",
          name: "title",
          placeholder: "",
          disabled: $setup.loading,
          onInput: $setup.validateTitleInput
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3)
      ]),
      ($setup.error_message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.error_message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: $setup.loading,
        onClick: _cache[0] || (_cache[0] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel ", 8 /* PROPS */, _hoisted_5),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $setup.loading }]),
        disabled: $setup.loading,
        onClick: $setup.createNewAsset
      }, " Add ", 10 /* CLASS, PROPS */, _hoisted_6)
    ]),
    _: 1 /* STABLE */
  }))
}